import { Button, Typography } from "@mui/material";
import { useState } from "react";

import type { LevelName, NewGame } from "src/api";

import { useGame } from "../../game/GameContext";
import "./MainMenu.css";
import { useGameScreenStore } from "./gameScreenStore";

const difficulties: LevelName[] = ["easy", "normal", "hard"] as const;

export function MainMenu() {
  const game = useGame();
  const switchToBoardScreen = useGameScreenStore(
    (state) => state.switchToBoard
  );

  const [currentDifficulty, setCurrentDifficulty] =
    useState<LevelName>("normal");
  const [startingError, setStartingError] = useState<string | null>(null);

  const gameSave = game.saved();

  async function startGame(options: NewGame) {
    setStartingError(null);

    const opened = await game.open(options);
    if (!opened.ok) {
      setStartingError(opened.refusal);
      return;
    }

    switchToBoardScreen();
  }

  return (
    <div className="main-menu">
      <img className="main-menu-logo" src="/brand/logo.png" />
      <div className="main-menu-buttons">
        {gameSave && (
          <Button
            variant="contained"
            onClick={() => startGame({ mode: "continue" })}
          >
            Continue
          </Button>
        )}
        <Button
          variant="outlined"
          onClick={() => startGame({ mode: "run", level: currentDifficulty })}
        >
          New Run
        </Button>
        <div className="main-menu-difficulty">
          {difficulties.map((difficulty) => (
            <Button
              key={difficulty}
              size="small"
              variant={
                difficulty === currentDifficulty ? "contained" : "outlined"
              }
              onClick={() => setCurrentDifficulty(difficulty)}
            >
              {difficulty}
            </Button>
          ))}
        </div>
        <Button variant="outlined" disabled>
          Versus
        </Button>
        <Button variant="outlined" disabled>
          Scenario
        </Button>
        {startingError && (
          <Typography variant="body2" color="error" align="center">
            {startingError}
          </Typography>
        )}
      </div>
    </div>
  );
}
